import React from "react"
import { AppAccessError } from "./AppAccessError"
import { useCurrentUser } from "../context/user/UserContext"
import { Box, Progress } from "@carrotfertility/carotene-core"
import useBenefit from "#/components/dynamic-content/hooks/useGetBenefit"

export const Loading = () => {
  const { userInfoLoadError } = useCurrentUser()
  const benefit = useBenefit()
  const hasError = userInfoLoadError || benefit.error
  return hasError ? <AppAccessError /> : <LoadingInner />
}

export const LoadingInner = () => {
  return (
    <Box
      display="flex"
      bgcolor={(theme) => theme.palette.info.light}
      justifyContent="center"
      alignItems="center"
      sx={{ blockSize: "100vb", inlineSize: "100vi" }}
    >
      <Progress />
    </Box>
  )
}
